import { render, staticRenderFns } from "./WdmAiRobot.vue?vue&type=template&id=be2a232e"
import script from "./WdmAiRobot.vue?vue&type=script&lang=js"
export * from "./WdmAiRobot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports